import React from 'react'
import { Route } from 'react-router-dom'

import TranslationsView from 'components/TranslationsView'

const IntranetRoutes = ({ match }) => (
  <>
    <Route exact path={`${match.path}/translations`} component={TranslationsView} />
  </>
)

export default IntranetRoutes
